var _path, _circle, _path2, _circle2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoIconSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0l7 8-7 8-7-8 7-8z",
    fill: "url(#infoIconSmall_svg__paint0_linear_49667_7481)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "url(#infoIconSmall_svg__paint1_linear_49667_7481)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6h2v5l-1 2-1-2V6z",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4,
    r: 1,
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "infoIconSmall_svg__paint0_linear_49667_7481",
    x1: 1,
    y1: 8.151,
    x2: 15,
    y2: 8.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514DDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02A7DB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "infoIconSmall_svg__paint1_linear_49667_7481",
    x1: 0,
    y1: 8.151,
    x2: 16,
    y2: 8.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#514DDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02A7DB"
  })))));
}

export default SvgInfoIconSmall;